import * as LJS from '../lib/littlejs.esm.js';
import Globals from './globals.ts';
const HUD_PADDING = 32;
const HUD_FONTSIZE = 32;
// Colors
const TRANSPARENT = LJS.hsl(0, 0, 0, 0);
export default class HUD {
    render() {
        let font = new LJS.FontImage;
        // LJS.drawRect(LJS.vec2(0), LJS.vec2(2, 2), Globals.BLACK, 0, true, true);
        // Display current score
        const depthText = `Depth: ${Math.floor(Globals.depth || 0)}`;
        LJS.drawTextScreen('███████████', LJS.vec2(24, HUD_PADDING + 24), 32, Globals.BLACK, 1, Globals.BLACK, 'left');
        font.drawTextScreen(depthText, LJS.vec2(HUD_PADDING, HUD_PADDING + HUD_FONTSIZE / 2), 2);
        // Display current health
        const healthText = `Health: ${Globals.player?.health || 0}`;
        LJS.drawTextScreen('███████████', LJS.vec2(24, HUD_PADDING + HUD_FONTSIZE * 2 + 8), 32, Globals.BLACK, 1, Globals.BLACK, 'left');
        font.drawTextScreen(healthText, LJS.vec2(HUD_PADDING, HUD_PADDING + HUD_FONTSIZE * 2), 2);
    }
}
